import AssignPanel from './assignPanel.container';

export default AssignPanel;
